<template>
  <div
    class="wrapper"
  >
    <span class="cart-mini">{{ strings.navbar.cart_ }}{{ cartUpdate.products.length ? `: ${cartUpdate.products.length}` : '' }}</span>
    <div
      v-if="showAlert"
      class="add-to-cart-alert"
    >
      <h3>{{ strings.cart.changed_ }}</h3>
      <p>{{ strings.cart.totalProducts_ }}: {{ cartUpdate.products.length }}</p>
      <p class="total-span">
        {{ strings.cart.final_ }}: {{ cartUpdate.totalPrice }} PLN
      </p>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'CartElement',
  data: function () {
    return {
      showAlert: false
    }
  },
  computed: {
    ...mapGetters([
      'cart', 'strings'
    ]),
    cartUpdate () {
      return Object.assign({}, this.cart)
    }
  },
  watch: {
    cartUpdate: {
      handler: function (oldCart, newCart) {
        this.showCartAlert()
      },
      deep: true
    }
  },
  methods: {
    showCartAlert () {
      this.showAlert = true
      setTimeout(() => {
        this.showAlert = false
      }, 4000)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSSn to this component only -->
<style scoped lang="scss">
.add-to-cart-alert {
  display: none;
}

.add-to-cart-alert p:hover {
  text-decoration: none;
}

@media (min-width: 992px) {
  .wrapper:hover {
    text-decoration: none;
  }
  .add-to-cart-alert {
    color: #000000;
    position: absolute;
    top: 530px;
    left: 20px;
    padding: 10px;
    overflow-y: auto;
    border: 1px solid #000000;
    z-index: 1001;
    display: block;
    font-size: 0.7rem;
    letter-spacing: 1.5px;
    background-color: #ffffff;
    // margin-left: -50px;
  }
  .cart-mini {
    height: auto;
    width: 20vw;
    display: block;
  }
  .cart-mini:hover {
    text-decoration: underline;
  }

  .add-to-cart-alert h3 {
    font-weight: bold;
    letter-spacing: 2px;
    font-size: 0.8rem;
    margin-bottom: 20px;
  }
  .cart-span {
    margin: 0;
  }
  .total-span {
    margin-top: 25px;
    font-weight: bold;
    font-size: 0.8em;
  }
}
</style>
